import AttendanceHooks from "./hooks";
import AttendanceHelpers from "./helpers";
import AttendanceModals from "./modals";

import "./attendance.scss";


const Attendance = {
    Hooks: AttendanceHooks,
    Helpers: AttendanceHelpers,
    Modals: AttendanceModals
};

export default Attendance;
